import React from "react";
import AddUserDialog from "./AddAuthorizationDialog.js";

import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
    marginLeft: "1rem",
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

export default function UploadContact(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Button
        style={{
          color: "#FFFFFF",
          backgroundColor: "#91C73C",
          fontWeight: "normal",
          fontWeight: "bold",
          height: "40px",
          fontSize: "0.75rem",
          padding: "5px 15px",
          marginLeft: "0px",
          marginRight: "0px",
          marginBottom: "0px",
          fontFamily: '"Source Sans Pro",sans-serif',

        }}
        onClick={handleClickOpen}
      >
        <AddIcon fontSize="small" style={{
          marginRight: "6px"
        }}/>
        Nouvelle autorisation
      </Button>

      <Dialog
        onClose={handleClose}
        aria-labelledby="adduser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Ajout d'une autorisation
        </DialogTitle>
        <DialogContent dividers>
          <AddUserDialog closeModal={handleClose}  {...props}/>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </div>
  );
}
